import { render, staticRenderFns } from "./MerchantManagementAdd.vue?vue&type=template&id=2a97f654&scoped=true"
import script from "./MerchantManagementAdd.vue?vue&type=script&lang=js"
export * from "./MerchantManagementAdd.vue?vue&type=script&lang=js"
import style0 from "./MerchantManagementAdd.vue?vue&type=style&index=0&id=2a97f654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a97f654",
  null
  
)

export default component.exports